import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { withLatestFrom, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { DocumentDownloadAction, ActionTypes } from '../../state/actions';
var DocumentComponent = /** @class */ (function () {
    function DocumentComponent(activateRoute, actions, store) {
        this.activateRoute = activateRoute;
        this.actions = actions;
        this.store = store;
        this.isLoading = true;
    }
    DocumentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.actions
            .pipe(ofType(ActionTypes.DOCUMENT_DOWNLOAD_SUCCESS, ActionTypes.DOCUMENT_DOWNLOAD_FAILURE), take(1))
            .subscribe(function (p) {
            _this.isLoading = false;
        });
        this.activateRoute.params
            .pipe(withLatestFrom(this.activateRoute.queryParams, this.activateRoute.data), untilDestroyed(this))
            .subscribe(function (_a) {
            var _b = tslib_1.__read(_a, 3), params = _b[0], queryParams = _b[1], data = _b[2];
            if (params.documentType !== 'letter') {
                var value = tslib_1.__assign({}, params, queryParams, data.theme, { clientname: data.theme.themeId });
                _this.store.dispatch(new DocumentDownloadAction(value));
            }
        });
    };
    DocumentComponent.prototype.ngOnDestroy = function () { };
    return DocumentComponent;
}());
export { DocumentComponent };
